import * as angular from 'angular';
import { config } from 'angular/utils/config';

class StorageLocationDetailsViewCtrl implements ng.IController {
    public storageLocation: StorageLocationDto;
    public isEditMode: boolean;
    public isCreateMode: boolean;
    public loggedInUser: LoginResult;
    public stageConfig = config;

    constructor(private $window) {}

    $onInit() {}

    public goBack(): void {
        this.$window.history.back();
    }
}

angular.module('app').component('pkpStorageLocationDetailsView', {
    controller: StorageLocationDetailsViewCtrl,
    template:
        require('app/storage-location/storage-location-details-view.component.html'),
    bindings: {
        form: '=',
        loggedInUser: '<',
        storageLocationId: '<',
        storageLocation: '=',
        isEditMode: '<?',
        isCreateMode: '<?'
    }
});
